"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductViewError = void 0;
/**
 * <h4>Product view send Error</h4>
 *
 * An error can be thrown from {@link sendProductView} invocation
 */
var ProductViewError = /** @class */ (function (_super) {
    __extends(ProductViewError, _super);
    function ProductViewError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, ProductViewError.prototype);
        return _this;
    }
    return ProductViewError;
}(Error));
exports.ProductViewError = ProductViewError;
//# sourceMappingURL=ProductViewError.js.map